import { Axios } from '@utils/api/axios-instance';
import { useMutation, UseMutationResult } from 'react-query';
import { TokenExtension } from '@utils/extensions/token.extension';

interface DocumentCreate {
  document_type: 'document' | 'caption';
  filename: string;
}

interface CreateSTTSessionPayload {
  language: string;
  keep_source: boolean;
  media_source?: string;
  diarization: boolean;
  document: DocumentCreate;
  punctuation?: boolean;
  multichannel?: boolean;
  folder_id?: number | null;
  min_speakers?: number | null;
  max_speakers?: number | null;
  export_template_id?: number | null;
}

interface STTSessionResponse {
  result: {
    session_id: string;
    status: string;
  };
}

const createSTTSession = async (
  payload: CreateSTTSessionPayload
): Promise<STTSessionResponse> => {
  const authToken = TokenExtension.get();

  const response = await Axios.post<STTSessionResponse>(
    '/api/v3/speech-to-text/session',
    payload,
    {
      headers: {
        Authorization: `Bearer ${authToken.string}`
      }
    }
  );

  return response.data;
};

export const useCreateSTTSession = (): UseMutationResult<
  STTSessionResponse,
  Error,
  CreateSTTSessionPayload
> => {
  return useMutation(createSTTSession);
};
